import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getOptions = async (activityId) => {
    const { data } = await vlqrApi.get(`/focusGroupRankingActivities/${activityId}/options`)
        .catch((error) => {
            handleError(error);
        });
    return data?.filter(x => !x.deletedOn);
};

const getOptionsForCrossSessionActivity = async (crossSessionActivityId) => {
    const { data } = await vlqrApi.get(`/focusGroupRankingActivities/crossSession/${crossSessionActivityId}/options`)
        .catch((error) => {
            handleError(error);
        });

    return data?.filter(x => !x.deletedOn);
};

const useRankingOptionsForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'rankingOptionsForCrossSessionActivity'
        : 'rankingOptionsForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],
        queryFn: () => crossSessionId
            ? getOptionsForCrossSessionActivity(crossSessionId)
            : getOptions(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default useRankingOptionsForActivity;
